import { render, staticRenderFns } from "./date-picker.vue?vue&type=template&id=20220022&"
import script from "./date-picker.vue?vue&type=script&lang=js&"
export * from "./date-picker.vue?vue&type=script&lang=js&"
import style0 from "./date-picker.vue?vue&type=style&index=0&id=20220022&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports